import utils from 'lib/utils';
import ResourcesCollection from 'ef/collections/resources_collection';
import EF from 'ef/ef';
import ErrorHandler from 'services/error-handler-service/handler';

const ResourceService = function () {
  this.getResources = function (resourceType, resourceSubType, withoutFiltering = true) {
    const contentId = EF.enrollment.get('contentId');
    //business_resource_contents => include business_resource
    //content_business_policies => include business_policy
    const urls = {
      resource: withoutFiltering
        ? `${EF.config.get('portalBasePath')}/business_resources.json?filter[content_id]=${encodeURIComponent(
            contentId
          )}`
        : `${EF.config.get('basePath')}/contents/${encodeURIComponent(
            contentId
          )}/business_resource_contents.json?include=business_resource&filter[content_id]=${encodeURIComponent(
            contentId
          )}`,
      policyresource: withoutFiltering
        ? `${EF.config.get('portalBasePath')}/business_policies.json?filter[content_id]=${encodeURIComponent(
            contentId
          )}`
        : `${EF.config.get('basePath')}/contents/${encodeURIComponent(
            contentId
          )}/content_business_policies.json?include=business_policy&filter[content_id]=${encodeURIComponent(
            contentId
          )}`,
    };
    urls.nationalresource = urls.resource;
    if (resourceType) {
      if (EF.resources?.length) {
        this.setSigned();
        return new Promise(resolve => resolve(EF.resources.byTypeSync(resourceType, resourceSubType)));
      } else {
        return this.fetch(urls[resourceType.toLowerCase()])
          .then(resources => {
            if (EF.resources) {
              EF.resources.add(
                new ResourcesCollection(resources, {
                  enrollment: EF.enrollment,
                }).models
              );
            } else {
              EF.resources = new ResourcesCollection(resources, {
                enrollment: EF.enrollment,
              });
            }
          })
          .then(() => {
            this.setSigned();
            return new Promise(resolve => resolve(EF.resources.byTypeSync(resourceType, resourceSubType)));
          });
      }
    } else {
      return new Promise((_resolve, reject) => reject());
    }
  };

  this.loadResources = function (withoutFiltering) {
    return Promise.all([
      this.getResources('PolicyResource', null, withoutFiltering),
      this.getResources('Resource', null, withoutFiltering),
    ])
      .then(() => {
        return Promise.resolve(EF.resources);
      })
      .catch(err => console.log('Error loading resources', err));
  };

  this.setSigned = () => {
    const signedPolicies = EF.enrollment
      .get('signed_business_policies')
      ?.filter(p => p.signed_at)
      ?.map(x => x.id);
    if (signedPolicies && signedPolicies.length > 0) {
      EF.resources.forEach(resource => {
        const id = resource.get('id');
        const policyId = parseInt(id.replace(`${resource.get('type')}-`, ''));
        const signed = signedPolicies.find(x => x === policyId);
        resource.set('signed', signed ? true : false);
      });
    }
  };

  this.fetch = function (url) {
    return fetch(url, {
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${EF.config.get('jwt')}`,
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return utils.sanifyJsonApiObject(data.data, data.included);
      });
  };

  this.save = function (resourceItem) {
    return fetch(`${EF.config.get('basePath')}/progress/${EF.enrollment.id}/policy_signatures.json`, {
      body: JSON.stringify({
        data: {
          type: 'policy_signature',
          attributes: {
            // split on first occurance of - to remove the type added for uniqueness
            policy_id: resourceItem.get('id').substring(resourceItem.get('id').indexOf('-') + 1),
            resource_type: 'PolicyResource',
          },
        },
      }),
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${EF.config.get('accessToken')}`,
        'Content-Type': 'application/vnd.api+json',
      },
      method: 'POST',
      mode: 'cors',
    })
      .then(response =>
        utils.httpErrorHandler(response, EF.resources.checkIfAllResourcesSigned(resourceItem?.get('sub_type')))
      )
      .then(jsonParser)
      .catch(err => {
        ErrorHandler.handle(err, 'warn');
        resourceItem.set('signed', false);
      });
  };

  const jsonParser = response => {
    return response.json();
  };
};

export default new ResourceService();
